module.exports = __webpack_public_path__ + "img/114.8.0ed4b5f8.png";